var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-row",
        [
          _c(
            "b-col",
            { attrs: { cols: "12", lg: "4", xl: "3" } },
            [
              _c(_vm.filtersComponentName, {
                tag: "component",
                attrs: {
                  showIncludedInSubscriptionFilter:
                    _vm.showIncludedInSubscriptionFilter
                },
                on: {
                  search: function($event) {
                    return _vm.search($event)
                  }
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-col",
            {
              staticClass: "search-container",
              attrs: { cols: "12", lg: "8", xl: "9" }
            },
            [
              (!_vm.inCompaniesSearch ||
                _vm.$store.getters["session/userIsProfessional"]) &&
              _vm.data.length > 0
                ? _c(
                    "div",
                    { staticClass: "search-result" },
                    _vm._l(_vm.data, function(item, index) {
                      return _c(
                        "div",
                        { key: item.profId || item.centerId },
                        [
                          index === 1 ? _c("search-banner-block") : _vm._e(),
                          _vm._v(" "),
                          _c("search-block", {
                            attrs: {
                              profId: item.profId,
                              centerId: item.centerId,
                              rating: item.rating,
                              isFavourite: item.isFavourite,
                              customPageUrl: item.customPageUrl,
                              name: item.name,
                              surnames: item.surnames,
                              showProfLogo: item.showProfLogo,
                              specialties: item.specialties,
                              introductoryText: item.introductoryText,
                              centers: item.centers,
                              languages: item.languages,
                              attendInsurance: item.attendInsurance,
                              photoUri: item.photoUri,
                              gender: item.gender,
                              consultations: item.consultations,
                              nextInplaceAvailability:
                                item.nextInplaceAvailability,
                              nextVideoAvailability: item.nextVideoAvailability,
                              nextInsuranceAvailability:
                                item.nextInsuranceAvailability,
                              servicesPackages: item.servicesPackages,
                              patientTPlanaWebmailHired:
                                item.patientTPlanaWebmailHired,
                              patientCompanyServices:
                                item.patientCompanyServices,
                              patientHiredServicesPackages:
                                item.patientHiredServicesPackages,
                              patientHasSpecialPrices:
                                item.patientHasSpecialPrices,
                              inplaceFirstAppointmentEnabled:
                                item.inplaceFirstAppointmentEnabled,
                              inplaceFirstAppointmentPrice:
                                item.inplaceFirstAppointmentPrice,
                              subspecialties: item.subspecialties,
                              minorRestricted: item.minorRestricted,
                              tarifaPlus: item.tarifaPlus,
                              accreditationState: item.accreditationState,
                              searchDisabled: item.searchDisabled,
                              noAllowChatFirstAppointment:
                                item.noAllowChatFirstAppointment,
                              selectedService: _vm.selectedService,
                              centerTown: item.town,
                              patientInfo: _vm.patientInfo
                            },
                            on: {
                              toggleIsFavourite: function($event) {
                                item.isFavourite = $event
                              },
                              showMinorRestrictedEvent: function($event) {
                                _vm.showMinorRestrictedModal = true
                              },
                              showInsurersEvent: _vm.getInsurers,
                              showTarifaPlusDisabledEvent:
                                _vm.showTarifaPlusDisabled,
                              showProfessionalPrevalidatedEvent:
                                _vm.showProfessionalPrevalidated,
                              showAvailabilityRequestEvent:
                                _vm.showAvailabilityRequest,
                              showServicesRequestEvent: _vm.showServicesRequest
                            }
                          })
                        ],
                        1
                      )
                    }),
                    0
                  )
                : _vm.inCompaniesSearch && _vm.data.length > 0
                ? _c(
                    "div",
                    { staticClass: "search-result" },
                    _vm._l(_vm.data, function(item) {
                      return _c("search-companies-block", {
                        key: item.profId,
                        attrs: {
                          profId: item.profId,
                          rating: item.rating,
                          customPageUrl: item.customPageUrl,
                          name: item.name,
                          surnames: item.surnames,
                          specialties: item.specialties,
                          introductoryText: item.introductoryText,
                          languages: item.languages,
                          photoUri: item.photoUri,
                          gender: item.gender,
                          subspecialties: item.subspecialties,
                          patientInfo: _vm.patientInfo
                        }
                      })
                    }),
                    1
                  )
                : _vm.emptySearch
                ? _c("h5", {
                    staticClass: "text-center",
                    domProps: {
                      innerHTML: _vm._s(_vm.$t("filters.emptySearch"))
                    }
                  })
                : _c("h5", {
                    staticClass: "text-center",
                    domProps: {
                      innerHTML: _vm._s(_vm.$t("filters.selectFilter"))
                    }
                  })
            ]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("base-dialog", {
        attrs: {
          content: _vm.$t("minorRestricted"),
          okFn: function() {
            _vm.showMinorRestrictedModal = false
          }
        },
        model: {
          value: _vm.showMinorRestrictedModal,
          callback: function($$v) {
            _vm.showMinorRestrictedModal = $$v
          },
          expression: "showMinorRestrictedModal"
        }
      }),
      _vm._v(" "),
      _c("base-dialog", {
        attrs: {
          content: _vm.insurers,
          title: _vm.$t("insurances"),
          okBtnText: _vm.$t("close"),
          okFn: function() {
            _vm.showInsurers = false
          }
        },
        model: {
          value: _vm.showInsurers,
          callback: function($$v) {
            _vm.showInsurers = $$v
          },
          expression: "showInsurers"
        }
      }),
      _vm._v(" "),
      _c("tarifa-plus-disabled-modal", {
        attrs: { userId: _vm.userId, isProfUser: _vm.isProfUser },
        model: {
          value: _vm.showTarifaPlusDisabledModal,
          callback: function($$v) {
            _vm.showTarifaPlusDisabledModal = $$v
          },
          expression: "showTarifaPlusDisabledModal"
        }
      }),
      _vm._v(" "),
      _c("professional-prevalidated-modal", {
        attrs: { profId: _vm.userId },
        model: {
          value: _vm.showProfessionalPrevalidatedModal,
          callback: function($$v) {
            _vm.showProfessionalPrevalidatedModal = $$v
          },
          expression: "showProfessionalPrevalidatedModal"
        }
      }),
      _vm._v(" "),
      _c("availability-request-modal", {
        attrs: {
          profId: _vm.availabilityRequestData.profId,
          specialties: _vm.availabilityRequestData.specialties,
          companyServices: _vm.availabilityRequestData.companyServices,
          appointmentTypeSelected:
            _vm.availabilityRequestData.currentSelectedServiceId
        },
        model: {
          value: _vm.showAvailabilityRequestForm,
          callback: function($$v) {
            _vm.showAvailabilityRequestForm = $$v
          },
          expression: "showAvailabilityRequestForm"
        }
      }),
      _vm._v(" "),
      _c("services-request-modal", {
        attrs: {
          userId: _vm.serviceRequestData.userId,
          selectedService: _vm.serviceRequestData.serviceId
        },
        model: {
          value: _vm.showServicesRequestForm,
          callback: function($$v) {
            _vm.showServicesRequestForm = $$v
          },
          expression: "showServicesRequestForm"
        }
      }),
      _vm._v(" "),
      _c("arrow-up")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0c20c2d3", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0c20c2d3","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/webapp/patient/search/Search.vue
// module id = 3664
// module chunks = 11